import { render, staticRenderFns } from "./sorted-select-list.vue?vue&type=template&id=48a6e4c2&scoped=true&"
import script from "./sorted-select-list.vue?vue&type=script&lang=js&"
export * from "./sorted-select-list.vue?vue&type=script&lang=js&"
import style0 from "./sorted-select-list.vue?vue&type=style&index=0&id=48a6e4c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a6e4c2",
  null
  
)

export default component.exports